













import { defineComponent, inject } from '@vue/composition-api'
import Categories from './components/category/Categories.vue'
import { alertSymbol } from '@/shared/state-management/symbols'
import { useStore as useTextbooksStore } from '@/shared/state-management/textbookStore'
import { Textbook } from '@/shared/types'

export default defineComponent({
  name: 'CategoryPage',
  components: {
    Categories,
  },
  setup(_props, { root }) {
    const { actions, getters } = useTextbooksStore()
    const { activeTextbook, loading } = getters
    const { deleteCategories, updateTextbook } = actions
    const $alert = inject(alertSymbol) as Function

    const onCategoryCreated = (textbook: Textbook) => {
      $alert({ text: root.$t('categories.created'), type: 'success' })
      updateTextbook(textbook)
    }

    const onCategoryEdited = (textbook: Textbook) => {
      $alert({ text: root.$t('categories.edited'), type: 'success' })
      updateTextbook(textbook)
    }

    const onCategoriesReordered = (textbook: Textbook) => {
      // $alert({ text: root.$t('categories.reordered'), type: 'success' })
      updateTextbook(textbook)
    }

    const onCategoriesDeleted = (ids: Array<{ id: string }>) => {
      $alert({ text: root.$t('categories.deleted'), type: 'success' })
      deleteCategories(ids.map((id: { id: string }) => id.id))
    }

    return {
      activeTextbook,
      onCategoryCreated,
      onCategoryEdited,
      onCategoriesDeleted,
      onCategoriesReordered,
      loading,
    }
  },
})
